'use client';
import { defaultCache } from './defaultCache/defaultCache.js';
import { defaultSerializer } from './defaultSerializer/defaultSerializer.js';
import { defaultStrategy } from './strategies/default.js';

// https://blog.risingstack.com/the-worlds-fastest-javascript-memoization-library/
var memoize = function memoize(fn, options) {
    var _ref = options || {}, _ref_cache = _ref.cache, cache = _ref_cache === void 0 ? defaultCache : _ref_cache, _ref_serializer = _ref.serializer, serializer = _ref_serializer === void 0 ? defaultSerializer : _ref_serializer, _ref_strategy = _ref.strategy, strategy = _ref_strategy === void 0 ? defaultStrategy : _ref_strategy;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
};

export { memoize };
